import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { getAllPrompts, create_prompt, deletePrompt } from "../../API/annotatorApi";
import { Edit2 } from 'react-feather';
import '../../Styles/Annotator/QuestionPrompt.css';

function QuestionPromptComponent(props) {
  const [questionData, setQuestionData] = useState([]);
  const [newQuestion, setNewQuestion] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedAdvice, setSelectedAdvice] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchQuestionData = async () => {
      try {
        let data = await getAllPrompts();
        setQuestionData(data.response);
      } catch (error) {
        console.error('Error fetching question data:', error);
      }
    };

    fetchQuestionData();
  }, []);

  const handleSubmit = async () => {
    try {
      await create_prompt(newQuestion, selectedCategory, selectedAdvice);
      let data = await getAllPrompts();
      setQuestionData(data.response);
    } catch (error) {
      console.error('Error submitting question:', error);
    }
  };

  const handleDelete = async (uid) => {
    try {
      // Assuming you have a delete function in your API
      await deletePrompt(uid);
      // Fetch updated data
      let data = await getAllPrompts();
      setQuestionData(data.response);
    } catch (error) {
      console.error('Error deleting question:', error);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const filteredData = questionData.filter((item) =>
    item.question.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const renderItems = currentItems.map((questionItem, index) => (
    <tr key={index}>
      <td>{questionItem.question}</td>
      <td>{questionItem.category}</td>
      <td>{questionItem.advice}</td>
      <td>
        <button onClick={() => handleDelete(questionItem.prompt_id)}>Delete</button>
      </td>
    </tr>
  ));

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(filteredData.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <div>
      {!props.lvreportDisplay&&
      <Button variant="info" onClick={() => setShowModal(true)}>
        <Edit2 />  Neu Prompt
      </Button>}

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Question Prompt Creation</Modal.Title>
        </Modal.Header>
        <Modal.Body className="wider-modal-body">
          <div className="search-container">
            <input
              className="search-input"
              type="text"
              value={searchTerm}
              onChange={handleSearch}
              placeholder="Search question"
            />
          </div>
          <table className="question-table">
            <thead>
              <tr>
                <th>Question</th>
                <th>Category</th>
                <th>AdviceID</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>{renderItems}</tbody>
          </table>
          <div className="pagination-container">
            <ul className="pagination">
              {pageNumbers.map((number) => (
                <li key={number}>
                  <button
                    className={`pagination-button ${currentPage === number ? 'active' : ''}`}
                    onClick={() => handlePageChange(number)}
                  >
                    {number}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="input-container">
            <h3>Add New Question</h3>
            <input
              type="text"
              value={newQuestion}
              onChange={(e) => setNewQuestion(e.target.value)}
              placeholder="Enter question"
            />
            <input
              type="text"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              placeholder="Enter category"
            />
            <input
              type="text"
              value={selectedAdvice}
              onChange={(e) => setSelectedAdvice(e.target.value)}
              placeholder="Enter advice ID"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => handleSubmit()}>Submit</Button>
          <Button onClick={() => setShowModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default QuestionPromptComponent;